(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();


        $( document ).ajaxError(function( event, jqxhr, settings, thrownError ) {

            if (jqxhr.status == 401 ){//unauthorised
                //force a refresh and then will redirect to login
                location.reload();
            }
        });

    });




    window.congratsMessage = function(title, text){

        var titles = [
            {'title':'Felicitari!','text':''},
        //    {'title':'Congrats!','text':''},
          //  {'title':'Hooray!','text':''},
          //  {'title':'Grooovy!','text':''},
         //   {'title':'Bravo!','text':''},
          //  {'title':'Respect :)','text':'Inca una si dai o cafea!'},
            ];

        var dummy = titles[Math.floor(Math.random() * titles.length)];

        if (text == undefined) var text ='';

        if (title == undefined) {
            var title = dummy.title;
            var text = dummy.text;
        }



        swal( {
            text: text,
            title: title,
            buttons: false,
            type: "success",
            timer: 3000,
            showConfirmButton: false,
        });

        $('.sweet-alert').first().attr('id', 'sweetdiv');
        var element =  document.getElementById('sweetdiv');

        // party.screen({
        //     count: 500 * (window.innerWidth / 1980),
        //     countVariation: 0.5,
        //     angleSpan: 0,
        //     yVelocity: -30,
        //     yVelocityVariation: 2,
        //     rotationVelocityLimit: 6,
        //     scaleVariation: 0.8
        // });

        let siteColors = ['#99C5FF', '#AFB9FA','#C8AEFC'];
        party.element(element, {
           // shape: ['star', 'heart'],
            count: 100,
           color: siteColors,
            spread: 360,
            gravity: false,
            size: party.minmax(7, 16),
            velocity: party.minmax(-300, -600),
            angularVelocity: party.minmax(2, 4)
        });
    }

   // window.congratsMessage();


    window.insetUnique=function($target){
        var ids = [];
        $target.children().each(function(){

            var id = $(this).attr('data-id');
            if (id != undefined){
                if (ids.indexOf(id) !== -1){
                    $(this).remove();
                }else{
                    ids.push(id);
                }
            }
        });
    }

    window.initSelectPicker= function(){
        $('[data-plugin="selectpicker"]').selectpicker({
            style: "btn-select",
            iconBase: "icon",
            tickIcon: "wb-check"
        });
    };


    window.initPreselect = function(){
        $('[data-modelpreselect]').each(function(){
           if ($(this).val() != '') return;
            var modelselect = $(this).parent().find('[data-content]');
            if (! modelselect.length || modelselect.length<2) return;
            var newvalue = modelselect.eq(1).text();
            $(this).val(newvalue);
        });
    };

    window.initPreselect();

    window.initCurrency = function(){
        $('[data-type="currency"]').each(function () {
            $(this).addClass('text-right');
            $(this).val($(this).val().replace(/\D+/g, ""));
            $(this).autoNumeric('init', {aSep: '.', aDec: ',', aSign: '', mDec: 0});
        });

        $('[data-type="currencydec"]').each(function () {
            $(this).addClass('text-right');
            //$(this).val($(this).val().replace(/\D+/g, ""));
            $(this).autoNumeric('init', {aSep: '.', aDec: ',', aSign: '', mDec: 2});
        });

        $('[data-type="currencydecmin"]').each(function () {
            $(this).addClass('text-right');
            //$(this).val($(this).val().replace(/\D+/g, ""));
            $(this).autoNumeric('init', {aSep: '.', aDec: ',', aSign: '', mDec: 1});
        });

    }

    window.initCurrency();

    window.initCountable = function(){
        var cid = 0;
        $('[data-countable]').each(function(){
            cid++;
            $(this).parent().append('<div id="countable'+cid+'" class="counter"></div>');
            $(this).simplyCountable({
                counter:            '#countable'+cid,
                countType:          'characters',
                maxCount:           $(this).data('countable'),
                strictMax:          false,
                countDirection:     'up',
                safeClass:          'safe',
                overClass:          'over',
                thousandSeparator:  ',',
            });
        });
    };

    window.initSingleCountable = function($element){
            $element.parent().find('.counter').remove();
            var cid= Date.now();
        $element.parent().append('<div id="countable'+cid+'" class="counter"></div>');
        $element.simplyCountable({
                counter:            '#countable'+cid,
                countType:          'characters',
                maxCount:           $element.data('countable'),
                strictMax:          false,
                countDirection:     'up',
                safeClass:          'safe',
                overClass:          'over',
                thousandSeparator:  ',',
            });

    };

    window.initCountable();


    window.getSelectedItems = function(target) {
        var $selectable = $(target+' [data-selectable]');
        var $selected = $selectable.asSelectable('getSelected');
        return $selected;
    };

    window.getSelectedItemsValues = function(target) {
        var items = getSelectedItems(target);
        var ret = [];
        $(items).each(function(){
            ret.push($(this).val());
        })

        return ret;
    }

    window.clear_form_elements = function(ele) {



        $(ele).find(':input').each(function() {
            switch(this.type) {
                case 'password':
                case 'select-multiple':
                case 'select-one':
                case 'text':
                case 'email':
                case 'textarea':
                    $(this).val('');
                    break;
                case 'checkbox':
                case 'radio':
                    this.checked = false;
            }

            $(this).closest('.form-group').removeClass('has-error');
            $(this).trigger('change');

            $('[data-plugin=selectpicker]').each(function(){
                $(this).selectpicker('refresh');
            });
        });


            if (window.city_select != undefined) window.city_select.clear();
            if (window.select_city_zones != undefined) window.select_city_zones.clear();



    };


    window.clear_form_elements_short = function(ele) {



        $(ele).find(':input').each(function() {
            switch(this.type) {
                case 'password':
                case 'select-multiple':
                case 'select-one':
                case 'text':
                case 'email':
                case 'textarea':
                    $(this).val('');
                    break;
                case 'checkbox':
                case 'radio':
                    this.checked = false;
            }

            $(this).closest('.form-group').removeClass('has-error');
            $(this).trigger('change');

            $('[data-plugin=selectpicker]').each(function(){
                $(this).selectpicker('refresh');
            });
        });


    };


    window.checkForm = function(target){

        var $target = $(target);
        if (! $target.length) return;

        if (!$(target)[0].checkValidity()) {
            window.inMessageError('Va rugam sa corectati erorile!');

            $(target+' :input').each(function() {
                if (!this.validity.valid) {
                    $(this).closest('.form-group').addClass('has-error');
                }else{
                    $(this).closest('.form-group').removeClass('has-error');
                }
            });


            $(target+' :input:visible[required="required"]').each(function()
            {
                if(!this.validity.valid)
                {
                    $(this).closest('.form-group').addClass('has-error');

                }else{
                    $(this).closest('.form-group').removeClass('has-error');
                }
            });


            $(target+' .selectized[required="true"]').each(function()
            {
                if(!this.validity.valid)
                {
                    $(this).closest('.input-group').addClass('has-error');
                    $(this).closest('.form-group').addClass('has-error');

                }else{
                    $(this).closest('.input-group').removeClass('has-error');
                    $(this).closest('.form-group').removeClass('has-error');
                }
            });

            return false;

        }

        return true;
    }

    window.initSlidePanel = function($target){
        var target = "#filter-result";
        $('[data-type="selectedcount"]').each(function(){
            //var target = $(this).attr('data-target');
            var self = this;

            $(target).on('selected:changed', function(){
                $(self).text(getSelectedItemsValues(target).length);
                var mytarget = $(self).attr('data-target');
                $(mytarget).val(getSelectedItemsValues(target));
            });
        });

        $(target).trigger('selected:changed');


        $('[data-type="filteredcount"]').each(function(){
            var self = this;
            $(target).on('filter:done', function(){
                $(self).text($(target).find('.filtercount').first().text());
            });
        });

        $(target).trigger('filter:done');

        window.initOnSelectable();


    };

    window.removeTooltips = function(){
        $('.tooltip').remove();
    };

    window.showSlidePanel = function (url){
        window.addToSlideHistory(url);
        $.slidePanel.show({
            url: url,
            settings: {
                cache: false
            }
        },  window.PanelOptions);
    }

    window.initOnSelectable = function() {
        $('[data-onselectable]').each(function () {
            $(this).slideUp(0);
            $.components._components.selectable.init();

            var starget ='#'+$(this).attr('data-onselectable');
            var $selectable = $(starget);

            var self = this;
            $selectable.on('asSelectable::change', function (e, api, checked) {

                $(self).postData = getSelectedItemsValues(starget);

                if (checked) {
                    $(self).slideDown();
                } else {
                    $(self).slideUp();
                }

            });
        });
    }

 var fullscreenurl = '';

   window.initPreview = function(url){

        var $fullscreener = $('#fullscreener');


       fullscreenurl = url;

       var $iframediv = $('#iframediv');

       if ($fullscreener.hasClass('hidden')) {
           $fullscreener.removeClass('hidden').fadeOut(0).fadeIn(500);
       }

        if (! $fullscreener.hasClass('initiated')) {
            $fullscreener.addClass('initiated');


            $('.fullscreenclose').on('click', function () {
                $iframediv.html('');
                $fullscreener.addClass('hidden');
                window.removeTooltips();
                $('body').trigger('preview:close');
            });

            $('.btn-iresize').on('click', function () {
                $('.btn-iresize').removeClass('active');
                $(this).addClass('active');
                $('iframe').animate({'max-width': $(this).data('iresize')}, 200);
            });

            $('#fullscreener .language-switch').on('click', function(e){
                e.preventDefault();
                window.loadInPreview(fullscreenurl+'?lang='+$(this).data('langswitch'));
            })

        }else{
            //  $('.btn-iresize.active').click();
        }
       $('#fullscreener .language-switch.active').click();
        $('.btn-iresize').first().click();


    }

    window.loadInPreview = function (url){
        var $iframediv = $('#iframediv');

        if ($iframediv.find('iframe').length){
            var iframe = $iframediv.find('iframe').first()
            iframe.attr('src', url);

        }else {
            var iframe = $('<iframe>', {
                'src': url
            });
            $iframediv.append(iframe);

            iframe.load(function(){
                 $(this).fadeIn(200);
            });
        }

        iframe.fadeOut(0);

    }


    window.mobilecheck = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

})(document, window, jQuery);
